import { Component } from '@angular/core';

import { pedidoProducao } from '../../pedido-status';

@Component({
    selector: 'sgt-pedido-status-badge-producao',
    templateUrl: './pedido-status-badge-producao.component.html',
    styleUrls: ['./pedido-status-badge-producao.component.less']
})
export class PedidoStatusBadgeProducaoComponent {
    status = pedidoProducao;
}
